/**
 * Des séances rangées par jour, les jours dans l'ordre du calendrier, chaque jour titré
 * (« Aujourd'hui », « Demain », « Vendredi 6 novembre ») — port de `groupOccurrencesByDate` et de ses
 * en-têtes. Dans un jour, l'ordre reçu est gardé : celui de l'appelant (la semaine du masteur garde
 * l'ordre de son accueil).
 */
import moment from "moment"

import { formatDayLabel, isToday } from "../../ui/formatters/dateFormatter"

export type DayGroup<T> = { id: string; title: string; isToday: boolean; sessions: T[] }

export function groupByDay<T extends { date: string }>(sessions: T[], relativeDayLabels = true): DayGroup<T>[] {
    const groups = new Map<string, DayGroup<T>>()
    for (const session of sessions) {
        const id = moment(session.date).format("YYYY-MM-DD")
        let group = groups.get(id)
        if (group == null) {
            group = {
                id,
                title: formatDayLabel(session.date, relativeDayLabels),
                isToday: isToday(session.date),
                sessions: [],
            }
            groups.set(id, group)
        }
        group.sessions.push(session)
    }
    return [...groups.values()].sort((a, b) => a.id.localeCompare(b.id))
}
